import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { optionchainModel } from './optionchain.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { TextBoxComponent } from 'src/app/text-box/text-box.component';
import { GotxGridComponent } from '../../../gotx/components/gotx-grid/gotx-grid.component';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { ExpiryDateComponent } from '../../components/ExpiryDate/ExpiryDate.component';

const customCss: string = '';

@Component({
  selector: 'app-optionchain',
  templateUrl: './optionchain.component.html'
})
export class optionchainComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('SymbolValue', { static: false }) SymbolValue: TextBoxComponent;
   // @ViewChild('ExpiryDate', { static: false }) ExpiryDate: TextBoxComponent;
   @ViewChild('cstmExpiryDate', { static: false }) cstmExpiryDate: ExpiryDateComponent;

    @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
    @ViewChild('gotxGridComp', { static: false }) gotxGridComp: GotxGridComponent;
    

  @Input('params') params: any = null;
  skeletonContentLoaded = false;
  symbol: string = '';
  symbolName = "NA";
  keyValueList: any[] = [];
  keyValueList1: any[] = [];
  keyValueList2: any[] = [];
  DetailList: any[] = [];
  exchSymbol: string = '';
  exchange: string = '';
  product: string = '';
  underLying: string = '';
  expirydate: string = '';
  underLyingType: string = '';
  stockName: string = ''; 
  ProductValueCalls: string  = "";
  ProductValuePuts: string  = "";
  selectedStockCalls: any;
  selectedStockPuts: any;
  subbedStock = null;
  productSelected = this.services.dataStore.getproductMasterData();
  expiryDateResponse = [];
  expiryDateResponseFinal:any;
  

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      //this.cstmProduct.revalidate(),
      //this.tabComponent_revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new optionchainModel();
    this.componentCode = 'OptionChain';
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
  }
  async onFormLoad() {
    console.log("onformload optionchain",this.params);
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    // this.cstmProduct.setReadOnly(true);
    this.setDependencies();
    this.reloadStock();

    /*if (this.params) {
      console.log("inside params");
      this.exchange = this.params.exchange;
      this.product = this.params.product;
      this.symbol = this.params.symbol;
      this.exchSymbol = this.params.exchSymbol;
      this.underLying = this.params.underlying;
      this.underLyingType = this.params.underlyingType,
      this.expirydate = this.params.expirydate;
      
      this.SymbolValue.setValue(this.underLying);
      //this.ExpiryDate.setValue(this.expirydate);
    }*/
      this.SymbolValue.setValue(this.underLying);

   
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'OptionChain';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    return this.additionalInfo;
  }
  getFieldValue() {
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.value = new optionchainModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
    this.productSelected = value;
  }

  ngOnInit() {
    console.log("ngOnInit option chain");
    if (this.formCode == undefined) { this.formCode = 'OptionChain'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    //styleElement.id = 'MarketDepth_customCss';
    if (this.params) {
      console.log("inside params",this.params);
      this.exchange = this.params.exchange;
      this.product = this.params.product;
      this.symbol = this.params.symbol;
      this.exchSymbol = this.params.exchSymbol;
      this.underLying = this.params.underlying;
      this.underLyingType = this.params.underlyingType,
      this.expirydate = this.params.expirydate;
      this.stockName = this.params.symbol
      
      //this.SymbolValue.setValue(this.underLying);
      //this.ExpiryDate.setValue(this.expirydate);
    }
    this.btnSubmit_click(event,"InitialRequest");
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    //var styleElement = document.getElementById('MarketDepth_customCss');
   // styleElement.parentNode.removeChild(styleElement);
    
  }
  ngAfterViewInit() {
    setTimeout(() => {
        console.log("ngAfterViewInit",this.params);
      this.subsBFldsValueUpdates();
      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new optionchainModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  cstmExpiryDate_ExpiryDateSelected(event) {
    console.log("expiry date in change",this.cstmExpiryDate.cmbExpiryDate.dropDownOptions.Options);
     var expirydatelist = this.cstmExpiryDate.cmbExpiryDate.dropDownOptions.Options;
       for( var i=0 ; i < expirydatelist.length ; i++){
        if(expirydatelist[i].text == ""){
          expirydatelist[i].text = expirydatelist[i].id;
        }

       }
       console.log("expiry date after new code",this.cstmExpiryDate.cmbExpiryDate.dropDownOptions.Options);
  }
 
  reloadStock() {
  
  }
  
  async btnSubmit_click(event,value) {
    console.log("this.exchange submit",this.exchange);
    let inputMap = new Map();
    //var errorCount: number = await this.revalidate();
   // document.getElementById('errMsgDiv').innerHTML = "";
    //if (errorCount == 0) {
      inputMap.clear();
      if(value == "InitialRequest"){
        inputMap.set('Body.symbol',this.underLying );
        inputMap.set('Body.exchange',this.exchange );
        inputMap.set('Body.product',this.product );
        inputMap.set('Body.underlying', this.underLyingType);
        inputMap.set('Body.stockName', this.stockName);
      }else{
        inputMap.set('Body.symbol',this.underLying);
        inputMap.set('Body.exchange',this.exchange);
        inputMap.set('Body.underlying', this.underLyingType);
        inputMap.set('Body.product',this.product );
        inputMap.set('Body.expirydate', this.cstmExpiryDate.cmbExpiryDate.getFieldValue());
        inputMap.set('Body.stockName', this.stockName);
      }
      
    //}
    this.services.http.fetchApi('/optionChain', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        console.log("res option chain",res);
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          var resp = res['response'];
          console.log("resp",resp.expiryDate);
          /*var resp=[{ "OI": "CBLPBOND", "Volume": "22", "NetChange": "DELIVERY", "LTP": "22", "BuyQty": "22", "BuyPrice": "LIMIT", "SellQty": "GFD", "SellPrice": "22", "StrikePrice": "22", "BuyQtys": 0, "BuyPrices": 0, "SellQtys":"10", "SellPrices": "22", "NetChanges": 0.0, "LTPs": 0.0, "OIs": "22","Volumes": "22" },
            { "OI": "pooja", "Volume": "22", "NetChange": "DELIVERY", "LTP": "22", "BuyQty": "22", "BuyPrice": "LIMIT", "SellQty": "GFD", "SellPrice": "22", "StrikePrice": "22", "BuyQtys": 0, "BuyPrices": 0, "SellQtys": "20", "SellPrices": "22", "NetChanges": 0.0, "LTPs": 0.0, "OIs": "22","Volumes": "22" }
            ];*/
         /* resp.forEach(element => {
       
          });*/
          if(resp.expiryDate != undefined ||resp.expiryDate != null || resp.expiryDate != "undefined"){
            console.log("inside if");
           for(let i =0 ; i<resp.expiryDate.length;i++){
            if (!this.expiryDateResponse.includes(resp.expiryDate[i].expirydate)) { // to prevent duplicate dates, 17apr2025:ssr
              this.expiryDateResponse.push(resp.expiryDate[i].expirydate);
            }
           }
            this.expiryDateResponseFinal = this.expiryDateResponse.map(date => ({id:date,text:date}));
           this.cstmExpiryDate.cmbExpiryDate.dropDownOptions.Options = this.expiryDateResponseFinal; 
          //this.cstmExpiryDate.cmbExpiryDate.dropDownOptions.Options = this.expiryDateResponse; 
           
          }
          console.log("this.expiryDateResponse",this.expiryDateResponse);
          this.gotxGridComp.gotxGrid.clearselection();
          if(resp.chainsForm){
            console.log("has grid data");
            this.gotxGridComp.reloadGrid(resp.chainsForm.chainsList);
            this.expiryDateResponse = [];
          }else{
            console.log("no grid data");
            this.gotxGridComp.reloadGrid([]);
          }
            //this.gotxGridComp.reloadGrid(resp.chainsForm.chainsList);
         
        }
        else {
          //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	  //commented by Shanmuga Priya - VAPT
          const rawMsg = res['errMsg'];
          const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
          (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
        }
      },
       async (httpError) => {
         var err = httpError['error']
         if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
         }
          this.services.alert.showAlert(2, "error part", -1);
      }
     );
  }
  
  datafields = [

    { name: 'callsOpeninterest', type: 'string' },
    { name: 'callsVolume', type: 'string' },
    { name: 'callsNetchange', type: 'string' },
    { name: 'callsLast', type: 'string' },
    { name: 'callsAsk', type: 'string' },
    { name: 'callsBid', type: 'string' },
    { name: 'strikeprice', type: 'number' },
    { name: 'putsAsk', type: 'string' },
    { name: 'putsBid', type: 'string' },
    { name: 'putsNetchange', type: 'string' },
    { name: 'putsLast', type: 'string' },
    { name: 'putsOpeninterest', type: 'string' },
    { name: 'putsVolume', type: 'string' },
    { name: 'callsTradingCode', type: 'string' },
    { name: 'putsTradingCode', type: 'string' },
    { name: 'callsBoard', type: 'string' },
    { name: 'callsExchange', type: 'string' },
    { name: 'callsProduct', type: 'string' },
    { name: 'putsBoard', type: 'string' },
    { name: 'putsExchange', type: 'string' },
    { name: 'putsProduct', type: 'string' },

  ];

  datatype = "json";
  columns: any[] =  [
    {
      text: '',columntype: 'button', width: "4%", align: 'center', columngroup: 'Options', cellsrenderer: (row) => {
        return "T";
      }, buttonclick: (row) => {
        this.buyButton_Click_CE(row);
      }
  },
    { text: this.transalte('OptionChainGrid.OI'), datafield: 'callsOpeninterest', width: 250, cellsalign: 'left', align: 'center' , columngroup: 'Calls'},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'callsVolume', width: 130, cellsalign: 'left', align: 'center', columngroup: 'Calls'},
    { text: this.transalte('OptionChainGrid.NetChange'), datafield: 'callsNetchange', width: 100, cellsalign: 'left', align: 'center', columngroup: 'Calls' },
    { text: this.transalte('OptionChainGrid.LTP'), datafield: 'callsLast', width: 100, cellsalign: 'left', align: 'center', columngroup: 'Calls' },
    { text: this.transalte('OptionChainGrid.Buy'),  datafield: 'callsBid', width: 100, cellsalign: 'right', align: 'center', columngroup: 'Calls' },
    { text: this.transalte('OptionChainGrid.Sell'),  datafield: 'callsAsk', width: 100, cellsalign: 'right', align: 'center', columngroup: 'Calls' },
    { text: this.transalte('OptionChainGrid.StrikePrice'), datafield: 'strikeprice', width: 100, cellsalign: 'right', align: 'center' },
    { text: this.transalte('OptionChainGrid.Buy'), datafield: 'putsBid', width: 100, cellsalign: 'right', align: 'center' , columngroup: 'Puts'},
    { text: this.transalte('OptionChainGrid.Sell'), datafield: 'putsAsk', width: 120, cellsalign: 'right' , columngroup: 'Puts'},
    { text: this.transalte('OptionChainGrid.NetChange'), datafield: 'putsNetchange', width: 100, cellsalign: 'left', align: 'center' , columngroup: 'Puts'},
    { text: this.transalte('OptionChainGrid.LTP'), datafield: 'putsLast', width: 100, cellsalign: 'left', align: 'center', columngroup: 'Puts' },
    { text: this.transalte('OptionChainGrid.OI'), datafield: 'putsOpeninterest',  width: 100, cellsalign: 'right', columngroup: 'Puts' },
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'putsVolume', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' },
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'callsTradingCode', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts',hidden:true },
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'putsTradingCode', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'callsBoard', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'callsExchange', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'callsProduct', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'putsBoard', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'putsExchange', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},
    { text: this.transalte('OptionChainGrid.Volume'), datafield: 'putsProduct', width: 100, cellsalign: 'right', cellsformat: 'f2', columngroup: 'Puts' ,hidden:true},


    {
      text: '', columntype: 'button', width: "4%", align: 'center', columngroup: 'Options', cellsrenderer: (row) => {
        return "T";
      }, buttonclick: (row) => {
        this.buyButton_Click_PE(row);
      }
  }
    
  ];
  columngroups: any[] = [
    { text: 'Calls', align: 'center', name: 'Calls' },
    { text: 'Puts', align: 'center', name: 'Puts' }
];

openOrderEntry(modal, rowIdx,value) {
  let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
  let stockKey = rowData.callsExchange + "#" + rowData.callsProduct + "#" +rowData.callsBoard+"#" + rowData.callsTradingCode;
  console.log("stockKey",stockKey);
      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
         this.selectedStockCalls = this.services.dataStore.stockMasterMap.get(stockKey);
         console.log("this.selectedStockCalls",this.selectedStockCalls);
        }
        this.ProductValueCalls = this.services.dataStore.convertProductMap(this.selectedStockCalls.underlyingType);

        let stockKeyPuts = rowData.putsExchange + "#" + rowData.putsProduct + "#" +rowData.putsBoard+"#" + rowData.putsTradingCode;
  console.log("stockKeyPuts",stockKeyPuts);
      if (this.services.dataStore.stockMasterMap.has(stockKeyPuts)) {
         this.selectedStockPuts = this.services.dataStore.stockMasterMap.get(stockKey);
         console.log("this.selectedStockPuts",this.selectedStockPuts);
        }
        this.ProductValuePuts = this.services.dataStore.convertProductMap(this.selectedStockPuts.underlyingType);
  let params:any;
  if(value == "CALLS"){
   params = {
      symbol: rowData.callsTradingCode,
      exchange: rowData.callsExchange,
      product: this.ProductValueCalls,
      // exchSymbol: this.marketData[idx].exchSymbol,
      board: rowData.callsBoard,
      // order: order,
     // price: '',
     // qty: '',
      orderEntryType: ''
      
  }
}else{
   params = {
    symbol: rowData.putsTradingCode,
    exchange: rowData.putsExchange,
    product: this.ProductValuePuts,
    // exchSymbol: this.marketData[idx].exchSymbol,
    board: rowData.putsBoard,
    // order: order,
   // price: '',
   // qty: '',
    orderEntryType: ''
    
}
}
  if (modal == "Sell") {
      params.orderEntryType = "SELL";
      /*if (rowData.lmtMaxAvailForSale > 0) {
          params.qty = rowData.lmtMaxAvailForSale;
      }*/

  } else if (modal == "Buy") {
      params.orderEntryType = "BUY";
  }
  const modalRef = this.services.openModal(gotxModalComponent, 'lg', params, modal);
  console.log("last params",params);
}

buyButton_Click_CE(event: any): void {
  this.openOrderEntry("Buy", event,"CALLS");
}
buyButton_Click_PE(event: any): void {
  this.openOrderEntry("Buy", event,"PUTS");
}


  transalte(text) {
    return this.services.translate.instant(text);
  }
  fieldDependencies = {
  }
  /* Write Custom Scripts Here */
}
